export default __webpack_public_path__ + "static/media/landing-1-circle-bottom-left.bb28d40e.svg";